<tmo-dynamic-modal
  [modal]="upgradeMultilineModal"
  *ngIf="aemContent && lineDetails"
  [displayModal]="displayModal"
>
  <p-header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="onUpgradeModalClose()"
        aria-label="Clickable action"
        id="cta-click-to-close"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
    <h3 id="select-existing-line-upgrade">{{ aemContent?.selectExistingLineUpgradeLabel }}</h3>
  </p-header>
  <div
    *ngFor="let line of lineDetails; let idx = index"
    class="row"
    aria-labelledby="verify"
    role="radiogroup"
  >
    <div class="col-12 m-t-md">
      <label class="form-label d-flex">
        <span class="radio m-r-sm">
          <input
            id="Upgrade_Line_{{ idx }}"
            (click)="selectLine(true, line?.lineOfServiceId)"
            type="radio"
            name="co-radio_sample1"
            aria-label="Radio"
          />
          <span class="radio-mask"></span>
        </span>
        <p class="content">
          <span *ngIf="line?.msisdn" id="Upgrade_Msisdn_{{ idx }}">
            {{ line?.msisdn | phone }}</span
          >
        </p>
      </label>
    </div>
  </div>
  <p-footer>
    <div class="row">
      <div class="col-12 button-spacing-legal">
        <button
          class="btn btn-primary"
          aria-label="Clickable action"
          id="select-upgrade-line"
          [disabled]="!isLineSelected"
          (click)="closeModal()"
        >
          {{ aemContent?.select }}
        </button>
      </div>
    </div>
  </p-footer>
</tmo-dynamic-modal>
